import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useNewsFilter } from '../features';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TheForm',
    setup(__props) {
        const { loading } = useNewsFilter();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", {
                class: _normalizeClass(["c-form--filterable-list", _unref(loading) ? 'is-loading' : 'is-success']),
                "data-css": "c-form"
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 2 /* CLASS */));
        };
    }
});
